import { en, MessageKey } from "./en";
import { pt } from "./pt";

const dictionaries: Record<string, Record<MessageKey, string>> = { en, pt };

// Language: ?lang= in the URL (the app can pass it), else the browser; English
// is the fallback.
const pickLanguage = (): string => {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get("lang");
    const raw = (fromUrl || navigator.language || "en").toLowerCase();
    const short = raw.slice(0, 2);
    return dictionaries[short] ? short : "en";
  } catch {
    return "en";
  }
};

const language = pickLanguage();

export const t = (key: MessageKey, vars: Record<string, string | number> = {}) => {
  const template = dictionaries[language]?.[key] ?? en[key];
  if (template === undefined) return key;
  return template.replace(/\{(\w+)\}/g, (_, name) =>
    vars[name] !== undefined ? String(vars[name]) : `{${name}}`
  );
};

export const hasMessage = (key: string): key is MessageKey => key in en;

export type { MessageKey };
